export default __webpack_public_path__ + "static/media/complementary--camera--g2.307561d6.png";